<template>
    <div class="page">
        <div class="pageBody">
            <van-swipe :autoplay="3000" class="swipe">
                <van-swipe-item v-for="(image, index) in detail.bannerList" :key="index">
                    <img v-lazy="image" style="width: 100vw; height: auto;"/>
                </van-swipe-item>
            </van-swipe>
            <h6 class="title">
                <span class="logo">{{detail.quizInfo.cropName}}</span>
                <span>{{detail.quizInfo.quizDesc}}</span>
            </h6>

            <div class="sub">
      <span>
        <img class="img" :src="detail.quizInfo.avatarImg" alt="">
        <b class="name">{{detail.quizInfo.nikeName}}</b>
      </span>
                <label class="time">{{dealData(detail.quizInfo.createTime)}}</label>
            </div>
            <!--<div class="process">浙江省—杭州市—滨江区—长河街道</div>-->

            <ul class="infomation">
                <li>
                    <b>近期用肥用药情况：</b>
                    <span>{{detail.quizInfo.fertilizeDrugState || '无'}}</span>
                </li>
                <li>
                    <b>种植时间：</b>
                    <span>{{moment(detail.quizInfo.createTime).format('YYYY年MM月DD日')}}</span>
                </li>
                <li>
                    <b>发生面积：</b>
                    <span>{{detail.quizInfo.occurrenceAreaStr}}</span>
                </li>
            </ul>

            <div class="recognize" v-if="detail.discernList.length>0">
                <h6>识别结果</h6>
                <ul>
                    <li v-for="(item) in detail.discernList" :key="'cell' + item.pdId">
                        <div class="img">
                            <img :src="item.typicalImg" alt="">
                        </div>
                        <span>{{item.pdName}}</span>
                        <label>相似度：{{item.dconf}}</label>
                    </li>
                </ul>
            </div>

            <div class="content">
                <h6>专家问答</h6>
                <ul>
                    <li v-for="item in commentList" :key="item.replyNo">
                        <img :src="item.replyAvatarImg" class="left" alt="">
                        <div class="right">
                            <h6>
                                <div class="title">
                                    <p class="name">{{item.replyNikeName}}</p>
                                    <p class="desc">zhuianji</p>
                                </div>
                                <span class="num" @click="toDownload">
                                    {{item.likeTotalNum || 0}}
                                </span>
                            </h6>
                            <p class="info">{{item.replyContent}}</p>
                            <footer class="footer">
                                <label class="time">{{dealData(item.createTime)}}</label>
                                <span class="reply" @click="toDownload">回复</span>
                            </footer>

                            <div class="children" v-if=" item.childReplayList.length > 0">
                                <ul>
                                    <li v-for="child in item.childReplayList" :key="child.replyNo">
                                        <img :src="child.replyAvatarImg" class="left" alt="">
                                        <div class="right">
                                            <h6>
                                                <div class="title">
                                                    <p class="name">{{child.replyNikeName}}</p>
                                                    <p class="desc">zhuianji</p>
                                                </div>
                                            </h6>
                                            <p class="info">{{child.replyContent}}</p>
                                            <footer class="footer">
                                                <label class="time">{{dealData(child.createTime)}}</label>
                                                <!--<span class="reply" @click="toDownload">回复</span>-->
                                            </footer>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
        <div class="fixedBottom">
            <div class="btn" @click="toDownload">
                <p>点击查看更多回复</p>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import {Lazyload} from 'vant';
  import moment from "moment"

  Vue.use(Lazyload);
  export default {
    data() {
      return {
        questionId: 0,
        detail: {
          bannerList: [],
          discernList: [],
          quizInfo: {}
        },
        commentList: [],
        moment: moment
      }
    },
    created() {
      this.questionId = this.$route.params && this.$route.params.id
      this.getQuestionDetailApi()
      this.getQuestionReplyApi()
    },
    mounted() {

    },
    methods: {
      //获取问答详情
      getQuestionDetailApi() {
        const {questionId} = this
        this.$api.getQuizDetail({questionId}).then(res => {
          console.log(res)
          if (res.code === 0) {
            res.data.discernList.forEach(item => {
              item.typicalImg = decodeURIComponent(item.typicalImg)
            })

            if (Array.isArray(res.data.quizInfo.replenishImg)) {
              res.data.quizInfo.replenishImg.forEach((item, index) => {
                res.data.quizInfo.replenishImg[index] = decodeURIComponent(item)
              })
            }
            res.data.bannerList = [
              decodeURIComponent(res.data.quizInfo.identifyImg),
              ...res.data.quizInfo.replenishImg
            ]
            this.detail = res.data
            let title = res.data.quizInfo.quizDesc
            if (title.length > 10) {
              title = title.slice(0, 10) + '...'
            }
            document.title = title
          }
        })
      },
      //获取评论
      getQuestionReplyApi() {
        const {questionId} = this
        this.$api.getReplylimit({questionId}).then(res => {
          console.log("comment", res)
          if (res.code === 0) {
            this.commentList = [...res.data]
            this.commentList = this.commentList.slice(0, 1)
          }
        })
      },

      /** 处理时间信息 **/
      dealData(time) {
        let timeWord = ""
        try {
          let mm =  moment(time)
          if (mm >= moment(0, "HH")) {
            //当天
            let format = mm.format("HH:mm")
            timeWord = "今天 " + format
          } else if (mm >= moment(0, "HH").add(-1, "day")) {
            // 昨天：昨天
            let format = mm.format("HH:mm")
            timeWord = "昨天 " + format
          } else if (mm >= moment().startOf("year")) {
            // 今年
            timeWord = mm.format("MM-DD HH:mm")
          } else {
            //之前的日期：YYYY-MM-DD
            timeWord = mm.format("YYYY-MM-DD HH:mm")
          }
        } catch (e) {
          console.warn(e)
        }
        return timeWord
      },

      //跳转下载
      toDownload() {
        this.$router.push({
          name: "quickLogin",
          query: this.$route.query || {}
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '@/styles/quertionAnswer/index';
</style>
